import { defineStore } from 'pinia';
import type { Station } from '~/types';

export interface State {
  pagination: {
    currentPage: number
    hasMore: boolean
  };
  station: Station
  months: string | undefined
}

export const useSubscriptionCatalogStore = defineStore('catalogStore', {
  state: (): State => ({
    pagination: {
      currentPage: 1,
      hasMore: true,
    },
    station: {
      id: 0,
      key: '',
      name: '',
      address: null,
      email: null,
      phone: null,
      parking_groups: null,
      element_type: 'station',
    },
    months: undefined,
  }),
});
